import './UserAvatar.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  shortName: string;
}

export const UserAvatar = observer(
  (props: IProps): ReactElement => (
    <div className='user-avatar'>
      <span className='short-name'>{props.shortName}</span>
    </div>
  )
);
